// 真实彩票模块 API（独立于 lotteryApi.js）
// 后端：/api/v3/lottery/*

const API_BASE = '/api/v3/lottery';

async function _fetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    return { success: false, message: `网络错误 (${res.status})` };
  }
  return data;
}

// =========================================================================
// 0. 模块状态
// =========================================================================
export async function getRlStatus() {
  return _fetch('/status');
}

// =========================================================================
// 1. KYC 实名
// =========================================================================
export async function getKyc(userId) {
  return _fetch(`/kyc?userId=${encodeURIComponent(userId)}`);
}

export async function submitKyc({ userId, realName, idCard }) {
  return _fetch('/kyc', {
    method: 'POST',
    body: JSON.stringify({ userId, realName, idCard }),
  });
}

// =========================================================================
// 2. 期号 / 开奖
// =========================================================================
export async function getCurrentPeriod(gameCode = 'ssq') {
  return _fetch(`/period/current?gameCode=${gameCode}`);
}

export async function getPeriodList(gameCode = 'ssq') {
  return _fetch(`/period/list?gameCode=${gameCode}`);
}

export async function getDrawResult(gameCode, period) {
  return _fetch(`/draw/${gameCode}/${period}`);
}

// =========================================================================
// 3. 下单
// =========================================================================
export async function createRlOrder({
  userId,
  gameCode = 'ssq',
  period,
  redBalls,
  blueBall,
  betCount = 1,
  multiple = 1,
}) {
  return _fetch('/order/create', {
    method: 'POST',
    body: JSON.stringify({ userId, gameCode, period, redBalls, blueBall, betCount, multiple }),
  });
}

// =========================================================================
// 4. 订单查询
// =========================================================================
export async function listRlOrders({ userId, status = 'all', page = 1, pageSize = 20 }) {
  const q = new URLSearchParams({ userId, status, page, pageSize }).toString();
  return _fetch(`/order/list?${q}`);
}

export async function getRlOrder(outTradeNo, userId) {
  const q = userId ? `?userId=${encodeURIComponent(userId)}` : '';
  return _fetch(`/order/${outTradeNo}${q}`);
}

export async function refreshRlOrder(outTradeNo) {
  return _fetch(`/order/${outTradeNo}/refresh`, { method: 'POST' });
}

// =========================================================================
// 5. 兑奖
// =========================================================================
export async function submitRlRedeem(outTradeNo, { userId, alipayAccount, alipayName }) {
  return _fetch(`/order/${outTradeNo}/redeem`, {
    method: 'POST',
    body: JSON.stringify({ userId, alipayAccount, alipayName }),
  });
}

export async function getRlRedeemStatus(outTradeNo) {
  return _fetch(`/order/${outTradeNo}/redeem-status`);
}

// =========================================================================
// 6. 积分
// =========================================================================
export async function getRlPoints(userId) {
  return _fetch(`/points?userId=${encodeURIComponent(userId)}`);
}

// =========================================================================
// 7. 工具
// =========================================================================
export const RL_STATUS_TEXT = {
  ticketing: '出票中',
  ticketed: '待开奖',
  ticket_failed: '出票失败',
  lost: '未中奖',
  won: '已中奖',
  redeeming: '兑奖中',
  redeemed: '已兑奖',
  redeem_failed: '兑奖失败',
};

export const RL_STATUS_COLOR = {
  ticketing: 'info',
  ticketed: 'primary',
  ticket_failed: 'default',
  lost: 'default',
  won: 'success',
  redeeming: 'warning',
  redeemed: 'success',
  redeem_failed: 'error',
};

export function fenToYuan(fen) {
  if (!fen) return '0.00';
  return (Number(fen) / 100).toFixed(2);
}
